import { render, staticRenderFns } from "./WorkList.vue?vue&type=template&id=d475e24c&scoped=true&"
import script from "./WorkList.vue?vue&type=script&lang=js&"
export * from "./WorkList.vue?vue&type=script&lang=js&"
import style0 from "./WorkList.vue?vue&type=style&index=0&id=d475e24c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d475e24c",
  null
  
)

export default component.exports